export const categories = [

  {
    name: 'Wallpaper',
    image: 'https://i.pinimg.com/236x/03/48/b6/0348b65919fcbe1e4f559dc4feb0ee13.jpg',
  },
  {
    name: 'Nature',
    image: 'https://i.pinimg.com/236x/b9/82/d4/b982d49a1edd984c4faef745fd1f8479.jpg',
  },
  
  {
    name: 'Fitness',
    image: 'https://i.pinimg.com/236x/25/14/29/251429345940a47490cc3d47dfe0a8eb.jpg',
  },
  
  {
    name: 'Photo',
    image: 'https://i.pinimg.com/236x/72/8c/b4/728cb43f48ca762a75da645c121e5c57.jpg',
  },
  {
    name: 'Food',
    image: 'https://i.pinimg.com/236x/7d/ef/15/7def15ac734837346dac01fad598fc87.jpg',
  },
  
  {
    name: 'Art',
    image: 'https://i.pinimg.com/736x/f4/e5/ba/f4e5ba22311039662dd253be33bf5f0e.jpg',
  }, {
    name: 'Travel',
    image: 'https://i.pinimg.com/236x/fa/95/98/fa95986f2c408098531ca7cc78aee3a4.jpg',
  },
  {
    name: 'sea',
    image: 'https://images.pexels.com/photos/1001682/pexels-photo-1001682.jpeg?auto=compress&cs=tinysrgb&w=1600',
  }, 
  {
    name: 'space',
    image: 'https://images.pexels.com/photos/1252890/pexels-photo-1252890.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1',
  },
  {
    name: 'Cats',
    image: 'https://i.pinimg.com/236x/6c/3c/52/6c3c529e8dadc7cffc4fddedd4caabe1.jpg',
  }, {
    name: 'Dogs',
    image: 'https://i.pinimg.com/236x/1b/c8/30/1bc83077e363db1a394bf6a64b071e9f.jpg',
  },
  {
    name: 'Cars',
    image: 'https://i.pinimg.com/750x/eb/47/44/eb4744eaa3b3ccd89749fa3470e2b0de.jpg',
  },
  {
    name: 'Others',
    image: 'https://i.pinimg.com/236x/2e/63/c8/2e63c82dfd49aca8dccf9de3f57e8588.jpg',
  },
];

export const userQuery = (userId) => {
    const query = `*[_type == 'user' && _id == '${userId}']`;

    return query;
}

// export const findPinId = (id) => {
  
//   const query = `*[_type == 'pin' && _id == '${id}']`
//     return query;
// }

export const pinDetailQuery = (pinId) => {
  const query = `*[_type == "pin" && _id == '${pinId}']{
    image{
      asset->{
        url
      }
    },
    _id,
    title, 
    about,
    category,
    destination,
    postedBy->{
      _id,
      userName,
      image
    },
   save[]{
      postedBy->{
        _id,
        userName,
        image
      },
    },
    comments[]{
      comment,
      _key,
      postedBy->{
        _id,
        userName,
        image
      },
    }
  }`;
  return query;
};

export const searchTerms = (search) => {
    const query = `*[_type == 'pin' && title match '${search}' || about match '${search}' ||category match '${search}'] 
                        {
                            image{
                                asset->{
                                  url
                                }
                              },

                            _id,
                            destination,
                            title,
                            about,
                            postedBy->{
                            _id,
                            userName,
                            image
                            },

                            save[]{
                            _key,
                            postedBy->{
                                _id,
                                userName,
                                image
                            },
                            },
                        }`

    return query;
}

export const searchSimilarCategory = (category) => {
  const query = `*[_type == 'pin' && title match '${category}' || about match '${category}' ||category match '${category}'] 
                      {
                          image{
                              asset->{
                                url
                              }
                            },

                          _id,
                          destination,
                          title,
                          about,
                          postedBy->{
                          _id,
                          userName,
                          image
                          },

                          save[]{
                          _key,
                          postedBy->{
                              _id,
                              userName,
                              image
                          },
                          },
                      }`

  return query;
}

export const feedQuery = `*[_type == "pin"] | order(_createdAt desc) {
      image{
        asset->{
          url
        }
      },
      _id,
      destination,
      title,
      about,
      postedBy->{
        _id,
        userName,
        image
      },
      save[]{
        _key,
        postedBy->{
          _id,
          userName,
          image
        },
      },
    } `;

    export const searchPinSaved = (userId) => {
      const query = `*[_type == 'pin' &&  '${userId}' in save[].userId ]
                          {
                              image{
                                  asset->{
                                    url
                                  }
                                },
    
                              _id,
                              destination,
                              title,
                              about,
                              postedBy->{
                              _id,
                              userName,
                              image
                              },
    
                              save[]{
                              _key,
                              postedBy->{
                                  _id,
                                  userName,
                                  image
                              },
                              },
                          }`
    
      return query;
    }

    export const searchPinCreated = (userId) => {
      const query = `*[_type == 'pin' &&  '${userId}' match userID]
                          {
                              image{
                                  asset->{
                                    url
                                  }
                                },
    
                              _id,
                              destination,
                              title,
                              about,
                              postedBy->{
                              _id,
                              userName,
                              image
                              },
    
                              save[]{
                              _key,
                              postedBy->{
                                  _id,
                                  userName,
                                  image
                              },
                              },
                          }`
    
      return query;
    }
    
